import React, {Component} from 'react';
import { Table, Tag, Avatar, Tooltip, Select  } from 'antd';
import {INTERVIEW_ROLE_TYPE_MAP, INTERVIEW_STATUS_TYPE_MAP} from "./NewsActivityBaseInfo";
import {Scrollbars} from "react-custom-scrollbars";
import { permissionCheck} from "../../utils";
import "./interview.css";
import wz from './text.png';
import wz_checked from './text_checked.png';
import sx from './sx.png';
import sx_checked from './sx_checked.png';
import mg from './mg.png';
import mg_checked from './mg_checked.png';
import sy from './sy.png';
import sy_checked from './sy_checked.png';
const { Option } = Select;

export const INTERVIEW_ROLE_TYPE_ICON_MAP = {
    type_1: wz_checked,
    type_2: sy_checked,
    type_3: sx_checked,
    type_4: mg_checked,
};
export const INTERVIEW_ROLE_DIFFICULTY_ARR = [{name:"简单",val:1},{name:"普通",val:2},{name:"困难",val:3},]

export const INTERVIEW_ROLE_PROPERTIES_MAP = {
    type_1: [{name:"消息",val:1},{name:"专题",val:2},],//文字
    type_2: [{name:"活动拍摄",val:1},{name:"策划拍摄",val:2},],
    type_3: [{name:"新闻",val:1},{name:"全录",val:2},{name:"专题",val:3},{name:"直播",val:4},],
};


class NewsActivityReporter extends Component {

    render() {
        return (
            <div style={{backgroundColor:"#f4f6fc",padding:"20px",width:"100%"}}>
                <Scrollbars
                    autoHeight
                    autoHeightMax={600}
                >
                <div style={{width:"100%", backgroundColor:"#fff", padding:"32px 40px"}}>
                    <NewsActivityReporterTable {...this.props}/>
                </div>
                </Scrollbars>
            </div>
        );
    }
}


export class NewsActivityReporterTable extends Component {

    columns = [
        {
            title: '记者',
            dataIndex: 'name',
            key: 'name',
            width:'120px',
            render:(text, record)=>{
                let sex = record.sex;
                let photo = "images/header_boys.png";
                if(record.photoUrl){
                    photo = record.photoUrl
                }else{
                    if(sex === 2){
                        photo = "/cm-sites/images/header_girls.png";
                    }
                }
                return <div style={{cursor:"default"}} className={"reporter-bold text-pointer"}>
                    <Tooltip placement={"topLeft"} title={text}>
                        <Avatar src={photo} style={{marginRight:"10px"}} size={35} />{text}
                    </Tooltip>
                </div>
            }
        },
        {
            /*
            roles:[1,2,3,4]
            */
            title: '类别',
            dataIndex: 'roles',
            key: 'roles',
            align:"center",
            className:"reporter-prop",
            render:(text, record)=>{
                const roles = [{text:"文字记者",icon:wz,iconChecked:wz_checked,key:"textjz_",type:1,propertiesDefault:1,difficultyDefault:1},
                    {text:"摄影记者",icon:sy,iconChecked:sy_checked,key:"syjz_",type:2,propertiesDefault:1},
                    {text:"摄像记者",icon:sx,iconChecked:sx_checked,key:"sxjz_",type:3,propertiesDefault:1},
                    {text:"美工包装",icon:mg,iconChecked:mg_checked,key:"gmbzjz_",type:4},
                ];
                if(this.props.edit){
                    return <div style={{textAlign:"center"}}>{
                        roles.map((item, index)=>{
                            let checked = record.roles && (record.roles.indexOf(item.type) !== -1);
                            return <Avatar key={"Avatar_edit_"+index} title={item.text}  src={checked?item.iconChecked:item.icon}
                                           style={{marginLeft:"10px",cursor:'pointer'}} size={35}
                                           onClick={()=>{
                                               this.setState(prevState=>{
                                                   prevState.dataSource.map(data=>{
                                                       if(data.account === record.account){
                                                           if(!data.roles){
                                                               data.roles = [];
                                                           }
                                                           if(data.roles.indexOf(item.type) !== -1){//之前选中了
                                                               data.roles = data.roles.filter(role=>{
                                                                   return role !== item.type;
                                                               });
                                                               delete data.roleRroperties["type_"+item.type];
                                                               if(item.difficultyDefault){
                                                                   data.difficulty = undefined;
                                                               }
                                                           }else{
                                                               data.roleRroperties = data.roleRroperties?data.roleRroperties:{};
                                                               if(item.propertiesDefault){
                                                                   data.roleRroperties["type_"+item.type] = item.propertiesDefault;
                                                               }
                                                               if(item.difficultyDefault){
                                                                   data.difficulty = item.difficultyDefault;
                                                               }
                                                               data.roles.push(item.type)
                                                           }
                                                           data.roles.sort();
                                                       }
                                                   });
                                                   this.props.onChange(prevState.dataSource);
                                                   return prevState;
                                               });
                                           }}
                            />
                        })
                    }</div>
                }else{
                    return text.map((role, index)=>{
                        return <Tooltip key={"Avatar_view_"+index} placement={"top"} title={INTERVIEW_ROLE_TYPE_MAP["type_" + role]}>
                            <Avatar title={INTERVIEW_ROLE_TYPE_MAP["type_" + role]} src={INTERVIEW_ROLE_TYPE_ICON_MAP["type_" + role]}
                                    style={{marginLeft:index===0?"0px":"10px",cursor:'pointer'}} size={35} />
                        </Tooltip>;
                    });
                }
            }
        },
      
        {
            title: '难度',
            dataIndex: 'difficulty',
            key: 'difficulty',
            className:"reporter-prop",
            align:"center",

            render:(text,record)=>{
                if(!this.props.edit){
                    let res = "";
                    INTERVIEW_ROLE_DIFFICULTY_ARR.map(item=>{
                        if(text){
                            if(item.val === parseInt(text)){
                                res = item.name;
                            }
                        }
                    });
                    return res;
                }
                let isShow = false;
                record.roles && record.roles.map(role=>{
                    if(("type_" + role) === "type_1"){//文字记者的时候才显示
                        isShow = true;
                    }
                });
                if(isShow){
                    return <Select value={text?parseInt(text):INTERVIEW_ROLE_DIFFICULTY_ARR[0].val}
                                   onChange={(value)=>{
                                       this.setState(prevState=>{
                                           prevState.dataSource.map(data=>{
                                               if(data.account === record.account){
                                                   data.difficulty = value;
                                               }
                                           });
                                           this.props.onChange(prevState.dataSource);
                                           return prevState;
                                       });
                                   }}
                    >
                        {INTERVIEW_ROLE_DIFFICULTY_ARR.map(item=>{
                            return <Option key={"difficulty_val" + item.val} value={item.val}>{item.name}</Option>
                        })}
                    </Select>
                }
                return "";
            }
        },
        {
            title: '属性',
            key: 'roleRroperties',
            dataIndex: 'roleRroperties',//{type_1: "1", type_2: "2", type_3: "2", type_4: ""}
            className:"reporter-prop",
            align:"center",

            render:(properties, record)=>{
                if(this.props.edit){
                    let res = [];
                    record.roles && record.roles.map(role=>{
                        INTERVIEW_ROLE_PROPERTIES_MAP["type_" + role] && res.push(<Select key={"roleRroperties_val_" + role}
                                         style={{marginLeft:(res.length > 0? "5px":"0px")}}
                                         value={properties["type_"+role]?parseInt(properties["type_"+role]):1}
                                         onChange={(value)=>{
                                             this.setState(prevState=>{
                                                 prevState.dataSource.map(data=>{
                                                     if(data.account === record.account){
                                                         data.roleRroperties = data.roleRroperties?data.roleRroperties:{};
                                                         data.roleRroperties["type_"+role] = value;
                                                     }
                                                 });
                                                 this.props.onChange(prevState.dataSource);
                                                 return prevState;
                                             });
                                         }}>
                        {
                            INTERVIEW_ROLE_PROPERTIES_MAP["type_" + role].map(item=>{
                                return <Option key={"roleRroperties_val_options_"+item.val} value={item.val}>{item.name}</Option>
                            })
                        }
                        </Select>);
                    });
                    return res.map(item=>item);
                }else{
                    let text = [];
                    for(let attr in properties){
                        if(INTERVIEW_ROLE_PROPERTIES_MAP[attr] && properties[attr]){
                            INTERVIEW_ROLE_PROPERTIES_MAP[attr].map(item=>{
                                if(item.val === parseInt(properties[attr])){
                                    text.push(item.name);
                                }
                            });
                        }
                    }
                    return text.join("、");
                }
            }
        },
        this.props.edit?
        {
            title: '操作',
            key: 'action',
            dataIndex: 'action',
            align:"center",
            width:'100px',
            className:"reporter-bold",
            render: (text, record, index) => {
                return this.props.btns(text, record, index);
            },
        }:
        {
            title: '领取状态',
            key: 'status',
            dataIndex: 'status',
            align:"center",
            render: status => {
                const STATUS_COLOR = {
                    type_1: "red",
                    type_2: "geekblue",
                    type_3: "green",
                    type_4: "gray",
                };
                return <Tag color={STATUS_COLOR["type_"+status]}>
                    {INTERVIEW_STATUS_TYPE_MAP["type_"+status]}
                </Tag>
            },
        },
    ];

    handleRoles = (oldRoles, newRoles)=>{
        if(newRoles instanceof Array){
            newRoles.map(_new=>{
                let isAdd = true;
                oldRoles.map(old=>{
                    if(old === _new){
                        isAdd = false;
                    }
                });
                if(isAdd){
                    oldRoles.push(_new);
                }
            });
        }else{
            let isAdd = true;
            oldRoles.map(old=>{
                if(old === newRoles){
                    isAdd = false;
                }
            });
            if(isAdd){
                oldRoles.push(newRoles);
            }
        }
    };

    handleProps = (oldProps, newProps)=>{
        for(let attr in newProps){
            oldProps[attr] = newProps[attr];
        }
    };

    handleData (data){
        let columns = [];
        data && data.map((item, index)=>{
            let isAdd = true;
            let newProps = {};
            if(item.interviewRole){
                if(INTERVIEW_ROLE_PROPERTIES_MAP["type_" + item.interviewRole]){
                    newProps["type_" + item.interviewRole] = item.properties;
                }
            }
            columns.map(column=>{
                if(column.account === item.account){
                    this.handleRoles(column.roles, item.interviewRole);
                    this.handleProps(column.roleRroperties, newProps);
                    isAdd = false;
                }
            });
            if(isAdd){
                columns.push({
                    key: index,
                    account: item.account,
                    name: item.jointerName,
                    sex: item.sex,
                    photoUrl: item.photoUrl,
                    roles: (item.interviewRole?[item.interviewRole]:[]),
                    difficulty: item.difficulty,
                    roleRroperties:newProps,
                    status: item.status,
                })
            }
        });
        return columns;
    }

    state = {
        dataSource:[]
    };

    componentWillMount() {
        this.setState({
            dataSource:this.handleData(this.props.data.interviewJointers)
        })
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            dataSource:this.handleData(nextProps.data.interviewJointers)
        })
    }

    render() {
        if( !permissionCheck("pms:newsActiviti:add") || !permissionCheck("pms:newsActiviti:edit") ) {
            this.columns.splice(2,2)
        }
        return <div className={"reporter-table-title"}>
            <Table columns={this.columns} dataSource={this.state.dataSource} pagination={false} />
        </div>;
    }
}

NewsActivityReporterTable.defaultProps = {
    data:{
        interviewJointers:[]
    },
    onChange:(dataSource)=>{}
};

export default NewsActivityReporter;